import React, { Component } from 'react';
import { Dimmer, Header, Loader, Modal } from 'semantic-ui-react';
import _ from 'lodash';
import { getSbrBidsHistory, getSingleBuyerRequestDetails } from '../../services/Project';
import RequestModalBidsSection from './RequestModalBidsSection'
import './RequestDetailsModal.less'

class RequestDetailsModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            files: [],
            request: {},
            showUploadControls: true,
            selectedImage: '',
            uploadButtonLoading: false,
            lbImages: [],
            selectedLBImage: 0,
            bids: []
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.open != this.props.open && this.props.open === true) {
            getSingleBuyerRequestDetails(this.props.singleBuyerRequestID).then(({ data }) => {
                this.setState({ request: data, selectedImage: data.images.length ? data.images[0].URL : '' })
            })
            getSbrBidsHistory(this.props.singleBuyerRequestID).then(({ data }) => {
                this.setState({ bids: data })
            })
        }

    }

    modalCloseHandler = () => {
        this.setState({ files: [], request: {}, bids: [] });
        this.props.closeHandler();
    }

    imageSelectHandler = (url) => {
        this.setState({ selectedImage: url })
    }

    render() {
        const { request } = this.state;
        const images = request.images || [];
        return <React.Fragment>

            <Modal
                closeIcon
                open={this.props.open}
                className='deals-details-modal'
                onClose={this.modalCloseHandler}
            >
                <Header className='deals-details-modal-header' content={`${request.service && request.service.name || 'Loading ...'} (${this.props.singleBuyerRequestID})`} />
                <Modal.Content>
                    <div className='deals-details-modal-container'>
                        <div className='deals-service-request-details'>
                            {request.sbr && request.sbr.serviceFormData ? request.sbr.serviceFormData.formPages[0].sections.map(section => {
                                section.fields = [...section.fields.filter((field) => {return field.isHidden != true })]
                                return (
                                section.isHidden ? "" :
                                <div className='deals-service-request-form-details'>
                                    <div className='deals-service-request-form-details-header'>{section.headerText}</div>
                                    {section.type == 'radio' ?
                                        <div className='deals-service-request-form-details-content-full'>
                                            <p  >{section.fields.find(f => f.value == 'checked') ? section.fields.find(f => f.value == 'checked').name : 'N/A'}</p>
                                        </div> :
                                        section.type == 'notes' ?
                                            <div className='deals-service-request-form-details-content-full'>
                                                <p>{section.fields[0].value || '-'}</p>
                                            </div> :
                                            Array(Math.ceil(section.fields.length / 2)).fill(0).map((num, index) => (
                                                <div className='deals-service-request-form-details-content-full'>
                                                    <div className='deals-service-request-form-details-content'>
                                                        <p>{section.fields[((index + 1) * 2) - 2].name}</p>
                                                        <h4>{section.type == 'multi' ? section.fields[((index + 1) * 2) - 2].value == 'checked' ? 'Yes' : 'No'
                                                            : section.fields[((index + 1) * 2) - 2].value || '-'}</h4>
                                                    </div>
                                                    { section.fields[((index + 1) * 2) - 1] ? <div className='deals-service-request-form-details-content'>
                                                        <p>{section.fields[((index + 1) * 2) - 1].name}</p>
                                                        <h4>{section.type == 'multi' ? section.fields[((index + 1) * 2) - 1].value == 'checked' ? 'Yes' : 'No'
                                                            : section.fields[((index + 1) * 2) - 1].value || '-'}</h4>
                                                    </div> : ''}
                                                </div>
                                            ))}
                                </div>
                                )
                            }
                            ) : <Dimmer active>
                                <Loader indeterminate size='massive' />
                            </Dimmer>}
                        </div>
                        {request.sbr ? <div className='deals-service-request-images'>
                            <div className='deals-service-request-images-heading'>Pictures</div>
                            {request.images && request.images.length ?
                                <>
                                    <div className='deals-service-request-big-image'>
                                        <img src={this.state.selectedImage} onClick={() => this.imageSelectHandler(this.state.selectedImage)} />
                                    </div>
                                    {images.map((img, imgIndex) =>
                                        <div className='deals-service-request-small-image'>
                                            <img src={img.URL} onClick={() => this.imageSelectHandler(img.URL)} />
                                        </div>
                                    )}
                                </> : <div className='deal-details-modal-no-images'> No Pictures found. </div>}
                            {/* <RequestModalBidsSection bids={this.state.bids} /> */}
                        </div> : ''}
                    </div>
                </Modal.Content>
            </Modal>
        </React.Fragment>
    }
}

export default RequestDetailsModal;